"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.transformArguments = void 0;
function transformArguments(value) {
    return [
        'CLIENT',
        'NO-TOUCH',
        value ? 'ON' : 'OFF'
    ];
}
exports.transformArguments = transformArguments;
